/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var OrganizationSettings;
(function (OrganizationSettings) {
    let contactIngestionFormat;
    (function (contactIngestionFormat) {
        contactIngestionFormat["SYMPLR"] = "symplr";
        contactIngestionFormat["ASCEND"] = "ascend";
        contactIngestionFormat["MGB"] = "mgb";
        contactIngestionFormat["WORKDAY_EXTERNAL"] = "workday_external";
    })(contactIngestionFormat = OrganizationSettings.contactIngestionFormat || (OrganizationSettings.contactIngestionFormat = {}));
    let externalApiFormat;
    (function (externalApiFormat) {
        externalApiFormat["WORKDAY"] = "workday";
    })(externalApiFormat = OrganizationSettings.externalApiFormat || (OrganizationSettings.externalApiFormat = {}));
})(OrganizationSettings || (OrganizationSettings = {}));
